import axios from 'axios';
import {
  AdType,
} from '../../types';
import { axiosConfig, serverUrl, streetsUrl } from '../../config';

export type MediaFile = {
  blobURL: string;
  _type: string;
};

export type IAdLoop = {
  mediaFile: MediaFile;
  duration: number;
  uniqueId: string;
  createdAt: number; // use to remove from queue
  pop?: string;
  type: AdType;
  weight: number;
};

type GetDeviceAdsProps = {
  partnerName?: string
};

export const getDeviceAds = async ({
  partnerName = '',
}: GetDeviceAdsProps): Promise<IAdLoop[]> => {
  // @ts-ignore
  const deviceId = window.DeviceApi.getDeviceId();

  try {
    const response = await axios.get(
      `${serverUrl}/external/ads/${deviceId}`,
      {
        ...axiosConfig,
        params: {
          partnerName,
        },
      },
    );

    return response?.data ? [response.data] : [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const delay = (ms: number): Promise<void> => new Promise((resolve) => { setTimeout(resolve, ms); });

export type AdsQueue = {
  poppedAdsQueue: IAdLoop[];
  serverQueue: IAdLoop[];
  // fallbackQueue: IAdLoop[]; // fallback ads
  weatherQueue: any[]
  newsQueue: any[]
};

export type QueueWeights = {
  [AdType.Fallback]: number,
  [AdType.Component]: number,
  [AdType.Server]: number,
  [AdType.Weather]: number,
  [AdType.News]: number
};

export type QueueConfig = {
  weights: QueueWeights;
  queueCap: Record<string, number>;
  clientAdRequestIntervals: Record<string, number>;
};

export const getQueueConfig = async (): Promise<QueueConfig | { error: unknown }> => {
  try {
    const response = await axios.get(`${streetsUrl}/queue-config`, axiosConfig);
    // console.log(response);
    // return {
    //
    //   weights: {
    //     provider: 80,
    //     direct: 5,
    //     component: 5,
    //     custom: 5,
    //     fallback: 5,
    //   },
    //   queueCap: {
    //     ads: 5,
    //   },
    //   clientAdRequestIntervals: {
    //     ms: 1000,
    //   },
    //
    // };
    return response.data;
  } catch (error) {
    return { error };
  }
};
